import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ApiResponse } from '@app/shared/models';
import { SyncLog } from '../models';
import { SyncLogDto } from '../models/sync-log.dto';

@Injectable({ providedIn: 'root' })
export class HttpService {
    private readonly httpClient = inject(HttpClient);

    syncItems(): Observable<void> {
        return this.httpClient.post<ApiResponse<null>>('api/product/sync', { force: false }).pipe(map(() => undefined));
    }

    syncStatus(): Observable<SyncLog> {
        return this.httpClient
            .skipErrorHandler()
            .get<ApiResponse<SyncLogDto>>('api/product/sync/log')
            .pipe(map((response) => new SyncLog(response.data)));
    }
}
